import { Routes } from '@angular/router';

export const adminRoutes: Routes = [
  {
        path: 'api-reference',
        loadComponent: () =>
          import('../features/api-reference/page/api-reference.component')
            .then((m) => m.ApiReferenceComponent),
      },
      {
        path: 'api-reference/mapping/:id',
        loadComponent: () =>
          import('../features/api-reference/page/api-reference-mapping.component')
            .then((m) => m.ApiReferenceMappingComponent),
      },
      {
        path: 'categories',
        loadComponent: () =>
          import('../features/categories/page/categories.component')
            .then((m) => m.CategoriesComponent),
      },
      {
        path: 'categories-manage',
        loadComponent: () =>
          import('../features/categories/page/categories.component')
            .then((m) => m.CategoriesComponent),
      },
      {
        path: 'categories/:code',
        loadComponent: () =>
          import('../features/categories/page/categories.component')
            .then((m) => m.CategoriesComponent),
      },
      {
        path: 'bieu-mau/:categoryId',
        loadComponent: () =>
          import('../features/bieu-mau/page/bieu-mau.component')
            .then((m) => m.BieuMauComponent),
      },

      {
        path: 'organizations',
        loadComponent: () =>
          import('../features/organizations/page/organizations.component')
            .then((m) => m.OrganizationsComponent),
      },
      {
        path: 'process',
        loadComponent: () =>
          import('../features/process/page/process.component')
            .then((m) => m.ProcessComponent),
      },
      {
        path: 'process/config/:id',
        loadComponent: () =>
          import('../features/process/component/configProcess/configProcess.component')
            .then((m) => m.ProcessConfigComponent),
      },
      {
        path: 'position/categoryType/:type',
        loadComponent: () =>
          import('../features/position/page/position.component')
            .then((m) => m.PositionComponent),
      },
      {
        path: 'criterion',
        loadComponent: () =>
          import('../features/nhom-chi-tieu/page/criterion.component')
            .then((m) => m.CriterionComponent),
      },
      {
        path: 'group-criterion',
        loadComponent: () =>
          import('../features/nhom-chi-tieu/page/group-criterion.component')
            .then((m) => m.GroupCriterionComponent),
      },
      {
        path: 'target-criterion',
        loadComponent: () =>
          import('../features/nhom-chi-tieu/page/target-criterion.component')
            .then((m) => m.TargetCriterionComponent),
      },
      {
        path: 'form',
        loadComponent: () =>
          import('../features/form/page/form.component')
            .then((m) => m.FormComponent),
      },
      {
        path: 'form-config',
        loadComponent: () =>
          import('../features/form-config/page/form-config.component')
            .then((m) => m.FormConfigComponent),
      },
      {
        path: 'business-log',
        loadComponent: () =>
          import('../features/business-log/page/business-log.component')
            .then((m) => m.BusinessLogComponent),
      },
      {
        path: 'api-log',
        loadComponent: () =>
          import('../features/api-log/page/api-log.component')
            .then((m) => m.ApiLogComponent),
      },
      {
        path: 'param-sync-config',
        loadComponent: () =>
          import('../features/param-sync/page/param-sync.component')
            .then((m) => m.ParamSyncComponent),
      },
      {
        path: 'user',
        loadComponent: () =>
          import('../features/users/page/users.component')
            .then((m) => m.UsersComponent),
      },
      {
        path: 'detail/:username',
        loadComponent: () =>
          import('../features/users/component/detailuser/user-edit.component')
            .then((m) => m.EditUser),
      },
      {
        path: 'profile/:username',
        loadComponent: () =>
          import('../features/users/component/profile/profile.component')
            .then((m) => m.Profile),
      },
      {
        path: 'user-group',
        loadComponent: () =>
          import('../features/user-group/page/user-group.component')
            .then((m) => m.UserGroupComponent),
      },
      {
        path: 'menu',
        loadComponent: () =>
          import('../features/menu/page/menu.component')
            .then((m) => m.MenuComponent),
      },
      {
        path: 'authorization-manage',
        loadComponent: () =>
          import('../features/decentralization-functions/page/decentralization-functions.component')
            .then((m) => m.DecentralizationFunctionsComponent),
      },
      {
        path: 'table',
        loadComponent: () =>
          import('../features/table/page/table.component')
            .then((m) => m.TableComponent),
      },
      {
        path: 'table/:status',
        loadComponent: () =>
          import('../features/table/page/table.component')
            .then((m) => m.TableComponent),
      },
      {
        path: 'table-config',
        loadComponent: () =>
          import('../features/table-config/page/table-config.component')
            .then((m) => m.TableConfigComponent),
      },
      {
        path: 'table-detail/:id',
        loadComponent: () =>
          import('../features/table-detail/page/table-detail.component')
            .then((m) => m.TableDetailComponent),
      },
      {
        path: 'dimplan',
        loadComponent: () =>
          import('../features/dim-du-an/page/dim-du-an.component')
            .then((m) => m.DimDuAnComponent),
      },
      {
        path: 'dim-nguoi-lao-dong',
        loadComponent: () =>
          import('../features/dim-nguoilaodong/page/dim-nguoilaodong.component')
            .then((m) => m.DimNguoiLaoDongComponent),
      },
      {
        path: 'dim-tai-san',
        loadComponent: () =>
          import('../features/dim-tai-san/page/dim-tai-san.component')
            .then((m) => m.DimTaiSanComponent),
      },
      {
        path: 'dim-chuc-danh',
        loadComponent: () =>
          import('../features/dim-chuc-danh/page/dim-chuc-danh.component')
            .then((m) => m.DimChucDanhComponent),
      },
      {
        path: 'dim-ngan-hang',
        loadComponent: () =>
          import('../features/dim-nganhang/page/dim-nganhang.component')
            .then((m) => m.DimNganHangComponent),
      },
      {
        path: 'dim-hop-dong',
        loadComponent: () =>
          import('../features/dim-hopdong/page/dim-hopdong.component')
            .then((m) => m.DimHopDongComponent),
      },
      {
        path: 'dim-khach-hang',
        loadComponent: () =>
          import('../features/dim-khachhang/page/dim-khachhang.component')
            .then((m) => m.DimKhachHangComponent),
      },
      {
        path: 'dim-chi-phi-thue-dat',
        loadComponent: () =>
          import('../features/dim-chiphithuedat/page/dim-chiphithuedat.component')
            .then((m) => m.DimChiPhiThueDatComponent),
      },
]